<template>
  <div class="nhbr-header">
    <!-- Component Body -->
  </div>
</template>

<script>
export default {
  name: 'NHBRHeader'
}
</script>

<style scoped>
/*** Component Style ***/
.nhbr-header {
  position: relative;
  background: url('./../assets/img/head.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position-x: right;
  height: 235px;
}
</style>